import React from "react";
import { Link } from "react-router-dom";  // Use react-router-dom's Link for navigation
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Tab = ({ tabName, icon, url, className }) => {
  return (
    <Link to={url}>  {/* Use 'to' prop for react-router-dom's Link */}
      <div className={className}>
        <div className="icon_wrapper">
          <FontAwesomeIcon icon={icon} className="icon" />
        </div>
        <div className="tab">
          <h4>{tabName}</h4>
        </div>
      </div>
    </Link>
  );
};

export default Tab;
